import { FallbackProps } from "react-error-boundary";
import { Button } from "./ui/button";
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "./ui/card";

function ErrFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <div className="flex h-screen flex-col items-center justify-center p-4 sm:p-8">
      <Card>
        <CardHeader>
          <CardTitle>Something went wrong! 🧐</CardTitle>
          <CardDescription className="mb-8 text-muted-foreground">
            {error.message}
          </CardDescription>
        </CardHeader>
        <CardFooter>
          <Button onClick={resetErrorBoundary}>Try again!</Button>
        </CardFooter>
      </Card>
    </div>
  );
}

export default ErrFallback;
